import { HttpInterceptorFn } from '@angular/common/http';
import { SpinnerService } from '../../services/spinner';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { CONSTANTS_DETAILS } from '../../shared/constant/constants';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerService = inject(SpinnerService);

  // Upload-related URLs that should not show the global spinner
  const uploadUrls = [
    CONSTANTS_DETAILS.UPLOAD_CHUNKS_URL,
    CONSTANTS_DETAILS.MERGE_UPLOADS_URL,
    CONSTANTS_DETAILS.MERGE_SESSION_URL,
  ];

  // Check if the current request is an upload request
  const isUploadRequest = uploadUrls.some((url) => req.url.includes(url));

  // Only show spinner for non-upload requests
  if (!isUploadRequest) {
    spinnerService.showSpinner();
  }

  return next(req).pipe(
    finalize(() => {
      // Only hide spinner if we showed it for this request
      if (!isUploadRequest) {
        spinnerService.hideSpinner();
      }
    }),
  );
};
